module.exports = __webpack_public_path__ + "static/media/santa-reliquia-cormoto-370-1.c788a23a.jpg";